'use client';

import { useTranslations } from 'next-intl';

import { Article } from '../article/Article';
import { Column, Grid } from '../grid/grid';
import { ImageSelector } from '../image-gallery/image-gallery';
import { Link } from '../link/link';
import { FragmentType, getFragmentData } from '@gql';
import { ContentPostFragment, ImageFragment } from 'lib/shared/content-posts-gql';
import { convertDate } from 'utils/convertDate';

type Content = FragmentType<typeof ContentPostFragment>;

interface ContentPostProps {
  content?: Content;
}

export function ContentPost({ content, locale }: ContentPostProps & { locale: string }) {
  const t = useTranslations('common');

  if (!content) return null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const data = getFragmentData(ContentPostFragment, content);
  const post = getFragmentData(ImageFragment, data);

  const articleDate = convertDate(locale, data.date);

  return (
    <>
      <Grid
        $fullWidth
        $fullHeight
      >
        {post?.image && post.image?.length === 1 ? (
          <Column $span={{ xs: 12, lg: 10 }}>
            <ImageSelector {...data} />
          </Column>
        ) : null}
        <Column $span={{ xs: 12, md: 6 }}>
          <Article
            title={data.title || ''}
            text={data.text || ''}
            date={articleDate}
            showDate={!!data.show_date}
          />
        </Column>
        {post?.image && post.image?.length > 1 ? (
          <Column $span={{ xs: 12, md: 6 }}>
            <ImageSelector {...data} />
          </Column>
        ) : null}
      </Grid>
      {data.next_post ? (
        <Column
          $span={{ xs: 12 }}
          $horizontalAlign="end"
        >
          <Link
            title={t('next')}
            url={`${locale === 'en' ? '/en/' : ''}${data.next_post}`}
          />
        </Column>
      ) : (
        <></>
      )}
    </>
  );
}
